import { useShopMetaStore } from '~/stores/shopMeta';
import { useShopStore } from '~/stores/shop';
import { useMemo } from 'react';

export const useShopInfo = () => {
  const shopInfo = useShopStore((state) => state.shopInfo);
  const shopMeta = useShopMetaStore((state) => state.shopMeta);

  const shopFuture = shopInfo?.future;
  const shopId = shopInfo?.shopID;
  const firstName = shopInfo?.firstName;
  const lastName = shopInfo?.lastName;
  const shopifyDomain = shopInfo?.shopifyDomain;
  const shopifyEmail = shopInfo?.email;
  const shopURL = shopifyDomain ? `https://${shopifyDomain}/` : '';

  const shopName = useMemo(
    () => (firstName && lastName ? `${firstName} ${lastName}`.trim() : ''),
    [firstName, lastName],
  );

  return {
    shopId,
    shopInfo,
    shopifyDomain,
    shopifyEmail,
    shopName,
    shopURL,
    shopFuture,
    shopMeta,
  };
};
